import type { CompositePrimaryKey, GlobalCollectionId } from '#layers/data-model/public';
import { useOverlay } from '@nuxt/ui/composables';
import { defineAsyncComponent } from 'vue';

const CollectionListingDrawer = defineAsyncComponent(() => import('#layers/listing/components/Collection/CollectionListingDrawer.vue'));

export function useCollectionItemPicker() {
	const overlay = useOverlay();

	return async function openCollectionItemPicker(
		collectionId: GlobalCollectionId,
		options: { selection: CompositePrimaryKey[] },
	): Promise<CompositePrimaryKey[] | null> {
		const modal = overlay.create(CollectionListingDrawer, {
			props: {
				collectionId,
				selectionMode: 'multiple',
				selection: options.selection,
			},
		});

		const result = await modal.open().result as { selection: CompositePrimaryKey[] } | undefined;

		return result?.selection ?? null;
	};
}
